import axios from "axios";
import { baseUrl } from "./baseUrl";
import { uploadImage, updateImage } from './imageApiV2';

const token = (localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t'));

// Create New Event Category
export const createEventCategory = async (data, image, toast, navigate) => {
    try {
        toast.loading('Creating Event Category...');

        // Upload logo to Image API V2 if provided
        if (image && image instanceof File) {
            console.log('📤 Uploading event category logo to Image API V2...');
            const imageResult = await uploadImage(image, 'events', false);

            data.logoId = imageResult.imageId;
            data.logoVersion = imageResult.version;
            data.logo = imageResult.url;

            console.log('✅ Event category logo uploaded:', imageResult);
        }

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/categories/create`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        const res = await axios.request(config);
        if (res.data.success) {
            toast.dismiss();
            toast.success(res.data.message);
            setTimeout(() => {
                navigate('/events/event-categories/view-categories');
            }, 2000);
        } else if (res.data?.error) {
            toast.dismiss();
            toast.error(res.data?.error?.message);
        } else {
            toast.dismiss();
            toast.error('An unknown error occurred.');
        }
    } catch (err) {
        console.error(err);
        toast.dismiss();
        const errorMessage = err.response?.data?.error?.message ||
                             err.response?.data?.message ||
                             'Something Went Wrong!';
        toast.error(errorMessage);
    }
}

// List Event Category
export const eventCategoryList = async (setData, toast) => {
    try {
        // toast.loading('Fetching Event Category List...');
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/categories/list`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        // console.log(res.data);
        if (res.data.success) {
            // toast.dismiss();
            setData(res.data.categories);
            // toast.success('List Challenge Category Refreshed!');
        }
        if (res.data?.error) {
            toast.dismiss();
            // toast.error(res.data?.error?.message);
            toast.error("Could not find categories!");
        }
    } catch (err) {
        toast.dismiss();
        toast.error('Something Went Wrong!');
    }
}

// Get Event Category To Edit
export const updateEventCategory = async (id, data, image, toast, navigate) => {
    try {
        toast.loading('Updating Event Category Details...');

        // Upload logo to Image API V2 if provided
        if (image && image instanceof File) {
            console.log('📤 Uploading event category logo to Image API V2...');

            // Use updateImage if logoId exists, otherwise upload new
            let imageResult;
            if (data.logoId) {
                imageResult = await updateImage(data.logoId, image);
                console.log('✅ Event category logo updated to version:', imageResult.version);
            } else {
                imageResult = await uploadImage(image, 'events', false);
                console.log('✅ Event category logo uploaded:', imageResult);
            }

            data.logoId = imageResult.imageId;
            data.logoVersion = imageResult.version;
            data.logo = imageResult.url;
        }

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/categories/update/${id}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        const res = await axios.request(config);
        console.log(res.data);
        if (res.data.success) {
            toast.dismiss();
            toast.success(res.data.message);
            setTimeout(() => {
                navigate('/events/event-categories/view-categories');
            }, 2000);
        } else if (res.data?.error) {
            toast.dismiss();
            toast.error(res.data?.error?.message);
        } else {
            toast.dismiss();
            toast.error('An unknown error occurred.');
        }
    } catch (err) {
        console.error(err);
        toast.dismiss();
        const errorMessage = err.response?.data?.error?.message ||
                             err.response?.data?.message ||
                             'Something Went Wrong!';
        toast.error(errorMessage);
    }
}

// Delete Event Category
export const deleteEventCategory = async (id, setData, toast) => {
    try {
        toast.loading('Deleting Event Category...');
        const config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/categories/delete/${id}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            toast.dismiss();
            setData(res.data.categories);
            toast.success(res.data.message);
            window.location.reload();
        }
        if (res.data?.error) {
            toast.dismiss();
            toast.error(res.data?.error?.message);
        }
    } catch (err) {
        toast.dismiss();
        toast.error('Something Went Wrong!');
    }
}

// Get Events Category To Edit
export const eventsCategoryEditView = async (id, data, setData, setActive, setImage, toast) => {
    try {
        // toast.loading('Fetching Events Category Details...');
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/categories/details/${id}`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            toast.dismiss();
            const updatedFields = data.map(field => ({
                ...field, value: res.data.category[field.name] || ''
            }));
            setData(updatedFields);
            setActive(res.data.category.active);
            setImage(res.data.category.logo);
            // toast.success('List Challenge Category Refreshed!');
        }
        if (res.data?.error) {
            toast.dismiss();
            toast.error(res.data?.error?.message);
        }
    } catch (err) {
        toast.dismiss();
        toast.error('Something Went Wrong!');
    }
}

// Get Event Category List
export const getEventCategoryList = async () => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/categories/list`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data.categories;
        }
        if (res.data?.error) {
            return [];
        }
    } catch (error) {
        console.log(error);
    }
}

// Get City List
export const getCityList = async () => {
    try {
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/city/list`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data.cities;
        }
        if (res.data?.error) {
            return [];
        }
    } catch (error) {
        console.log(error);
    }
}

// Create Event
export const createEvent = async (data, coverImage) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (coverImage && coverImage instanceof File) {
            console.log('📤 Uploading event cover image to Image API V2...');
            const imageResult = await uploadImage(coverImage, 'events', false);

            data.coverImageId = imageResult.imageId;
            data.coverImageVersion = imageResult.version;
            data.coverImage = imageResult.url;

            console.log('✅ Event cover image uploaded:', imageResult);
        }

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/create`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        const res = await axios.request(config);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Get Events List
export const getEventsList = async () => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/list`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data.events;
        }
        if (res.data?.error) {
            return [];
        }
    } catch (error) {
        console.log(error);
    }
}

// Delete Event
export const deleteEvent = async (id) => {
    try {
        const config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/delete/${id}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data;
        }
    } catch (err) {
        console.log(err);
    }
}

// Get events details by id
export const getEventDetails = async (id) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/details/${id}`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data.event;
        }
        if (res.data?.error) {
            return {};
        }
    } catch (error) {
        console.log(error);
    }
}

// Update event
export const updateEvent = async (id, data, coverImage) => {
    try {
        // Upload cover image to Image API V2 if provided
        if (coverImage && coverImage instanceof File) {
            console.log('📤 Uploading event cover image to Image API V2...');

            // Use updateImage if coverImageId exists, otherwise upload new
            let imageResult;
            if (data.coverImageId) {
                imageResult = await updateImage(data.coverImageId, coverImage);
                console.log('✅ Event cover image updated to version:', imageResult.version);
            } else {
                imageResult = await uploadImage(coverImage, 'events', false);
                console.log('✅ Event cover image uploaded:', imageResult);
            }

            data.coverImageId = imageResult.imageId;
            data.coverImageVersion = imageResult.version;
            data.coverImage = imageResult.url;
        }

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/update/${id}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        const res = await axios.request(config);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Get event submission list
export const getEventSubmissionList = async () => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/submissions/list`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data.eventSubmissions;
        }
        if (res.data?.error) {
            return [];
        }
    } catch (error) {
        console.log(error);
    }
}

// Get Event Submission Details
export const getEventSubmissionDetails = async (id) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/admin/events/submissions/details/${id}`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        };
        const res = await axios.request(config);
        if (res.data.success) {
            return res.data?.eventSubmissionsDetails;
        }
        if (res.data?.error) {
            return {};
        }
    } catch (error) {
        console.log(error);
    }
}


export const acceptEventSubmission = async (data) => {
    try {
        const res = await axios.post(`${baseUrl}/admin/events/submissions/approve`, data);
        return res.data;
    } catch (error) {
        console.log(error);
    }
}

export const rejectEventSubmission = async (data) => {
    try {
        const res = await axios.post(`${baseUrl}/admin/events/submissions/reject`, data);
        return res.data;
    } catch (error) {
        console.log(error);
    }
}